
function IntegrationScopeService($resource, $routeParams, $http, $cacheFactory, $q, $filter, ToastService) {

    //--------------------------------------//
    //              Private                 //
    //--------------------------------------//

    var serviceCache = $cacheFactory('IntegrationScopeService');
    var baseUrl = '../Api/IntegrationScopeApi';

    var res = $resource(baseUrl + '/:id', {}, {
        get: { method: 'GET', params: { id: 'id' }, isArray: false, cache: serviceCache },
        getQueues: { method: 'GET', params: { id: 'id', skipNumber: '0', takeNumber: '5' }, isArray: true },
        getScopes: { method: 'GET', params: { id: 'id', skipNumber: '0', takeNumber: '10', errorOnly: false }, isArray: true },
        //getScopeValues: { method: 'GET', params: { id: 'id', actionTag: 'SCOPEVALUES' }, isArray: false, cache: serviceCache },
        getProcessedValues: { method: 'GET', params: { id: 'id', actionTag: 'PROCESSEDVALUES' }, isArray: false, cache: serviceCache },
        getDecodedValues: { method: 'GET', params: { id: 'id', actionTag: 'DECODEDVALUES' }, isArray: false, cache: serviceCache },
        //getProperty: { method: 'GET', params: { id: 'id', propName: 'propName', actionTag: 'PROPERTY_REQUESTBODY' }, isArray: false, cache: serviceCache },
        processData: { method: 'GET', params: { integrationID: 'integrationID', actionTag: 'PROCESS' }, isArray: false },
        reprocessIntegration: { method: 'GET', params: { integrationID: 'integrationID', startTime: 'startTime', endTime: 'endTime', isToExecute: 'isToExecute' }, isArray: false },
        put: { method: 'PUT', params: { data: 'data' }, isArray: false },
        'delete': { method: 'DELETE', params: { id: 'id' }, isArray: false },
        deleteBatch: { method: 'DELETE', params: { ids: 'ids' }, isArray: false },
        action: { method: 'GET', params: { id: 'id', actionTag: 'actionTag' }, isArray: false }
    });

    var integrationScopes = $cacheFactory('Scopes');
    var integrationQueues = $cacheFactory('Queues');

    function getScope(key) {
        return integrationScopes.get(key);
    }

    function setScope(key, value) {
        var scope = getScope(key);

        if (scope) {
            angular.extend(scope, value);
        }
        else {
            scope = value;
        }
        integrationScopes.put(key, scope);
    }

    function getQueues(key) {
        return integrationQueues.get(key);
    }

    function setQueues(key, value) {
        var queues = getQueues(key);
        if (queues) {
            angular.extend(queues, value);
        }
        else {
            queues = value;
        }
        integrationQueues.put(key, queues);
    }

    function createPreviewValues(scopeItem) {
        return scopeItem;
    }

    //--------------------------------------//
    //                 Public               //
    //--------------------------------------//


    this.resetCache = function () {
        serviceCache.removeAll();
        integrationScopes.removeAll();
    };

    this.updatePreviewValues = function (scopeItem) {

        console.log('UPDATEPREVIEWVALUES [' + scopeItem.ScopeValues + ']');

        scopeItem.ProcessedValuesPreview = scopeItem.ProcessedValues;
        if (scopeItem.ScopeValues) {
            scopeItem.ScopeValuesPreview = scopeItem.ScopeValues;
        }
        if (scopeItem.DecodedValues) {
            scopeItem.DecodedValuesPreview = scopeItem.DecodedValues;
        }
        return scopeItem;
    };

    

    this.getScopeQueues = function (scopeID, skipNumber, takeNumber) {
        return $q(function (resolve, reject) {
            var toastID = ToastService.createToast('', 'Carregando Queues', 0, 'wait');
            res.getQueues({ id: scopeID, skipNumber: skipNumber, takeNumber: takeNumber }, function (data) {
                setQueues(scopeID, data);
                resolve(data);
                ToastService.removeToast(toastID);
            }, function errorFunc(errorDescription) {
                ToastService.removeToast(toastID);
                ToastService.createToast('Erro ao carregar as queues', errorDescription, 8000, 'error');
                reject(errorDescription);
            });
        });
    };

    this.getProperty = function (scopeID, propName) {
        return $q(function (resolve, reject) {
            var scope = getScope(scopeID);
            if (scope && scope[propName]) {
                resolve(scope);
            }
            else {
                var toastID = ToastService.createToast('', 'Carregando dados', 0, 'wait');
                res.getProperty({ id: scopeID }, function (data) {
                    setScope(scopeID, data);
                    resolve(data);
                    ToastService.removeToast(toastID);
                }, function errorFunc(errorDescription) {
                    ToastService.removeToast(toastID);
                    ToastService.createToast('Erro ao carregar os dados', errorDescription, 8000, 'error');
                    reject(errorDescription);
                });
            }
        });
    };

    

    this.getProcessedValues = function (scopeID) {
        return $q(function (resolve, reject) {
            var scope = getScope(scopeID);
            if (scope && scope.ProcessedValues) {
                resolve(scope);
            }
            else {
                var toastID = ToastService.createToast('', 'Carregando dados', 0, 'wait');
                res.getProcessedValues({ id: scopeID }, function (data) {
                    setScope(scopeID, data);
                    resolve(data);
                    ToastService.removeToast(toastID);
                }, function errorFunc(errorDescription) {
                    ToastService.removeToast(toastID);
                    ToastService.createToast('Erro ao carregar os dados', errorDescription, 8000, 'error');
                    reject(errorDescription);
                });
            }
        });
    };

    this.getDecodedValues = function (scopeID) {
        return $q(function (resolve, reject) {
            var scope = getScope(scopeID);
            if (scope && scope.DecodedValues) {
                resolve(scope);
            }
            else {
                var toastID = ToastService.createToast('', 'Carregando dados decodificados', 0, 'wait');
                res.getDecodedValues({ id: scopeID }, function (data) {
                    setScope(scopeID, data);
                    resolve(data);
                    ToastService.removeToast(toastID);
                }, function errorFunc(errorDescription) {
                    ToastService.removeToast(toastID);
                    ToastService.createToast('Erro ao carregar os dados decodificados', errorDescription, 8000, 'error');
                    reject(errorDescription);
                });

            }

        });
    };

    this.reprocessIntegration = function (integrationID, startTime, endTime, isToExecute) {
        return $q(function (resolve, reject) {
            var text = 'Verificando itens afetados';

            if (isToExecute) {
                text = 'Reprocessando integrações';
            }

            var toastID = ToastService.createToast('', text, 0, 'wait');

            res.reprocessIntegration({ integrationID: integrationID, startTime: startTime, endTime: endTime, isToExecute: isToExecute }, function (data) {
                resolve(data);
                ToastService.removeToast(toastID);
            }, function errorFunc(errorDescription) {
                ToastService.removeToast(toastID);
                ToastService.createToast('Erro ao adicionar ao reprocessar', errorDescription, 8000, 'error');
                reject(errorDescription);
            });
        });
    };

    

    this.save = function (scope) {
        return $q(function (resolve, reject) {

            var toastID = ToastService.createToast('', 'Salvando', 0, 'wait');

            $http.post(baseUrl, scope).
              then(function (data) {
                  setScope(data.data.ScopeID, data.data);
                  resolve(data.data);
                  ToastService.removeToast(toastID);
              }, function errorFunc(errorDescription) {
                  ToastService.removeToast(toastID);
                  ToastService.createToast('Erro ao salvar', errorDescription, 8000, 'error');
                  reject(errorDescription);
              });
        });
    };

    this.update = function (scope) {
        return $q(function (resolve, reject) {
            var toastID = ToastService.createToast('', 'Atualizando', 0, 'wait');
            $http.put(baseUrl, scope).
              then(function (data) {
                  setScope(scope.ScopeID, data.data);
                  resolve(data.data);
                  ToastService.removeToast(toastID);
              }, function errorFunc(errorDescription) {
                  ToastService.removeToast(toastID);
                  ToastService.createToast('Erro ao salvar', errorDescription, 8000, 'error');
                  reject(errorDescription);
              });
        });
    };

    this.getMaterialCaract = function (plantID, vehicleID, partID) {
        return $http.get(baseUrl + '/GetMaterialCaract', {
            params: { plantID: plantID, vehicleID: vehicleID, partID: partID },
            cache: serviceCache
        });
    }

    //---------------------------------------
    // JRM: ATUALIZADOS
    //---------------------------------------

    this.getScopeValues = function (scopeID) {
        return $http.get(baseUrl + '/GetScopeValues', {
            params: { scopeID: scopeID },
            cache: serviceCache
        });
    };

    this.getProperty = function (scopeID, propertyToRead) {
        return $http.get(baseUrl + '/GetProperty', {
            params: {
                scopeID: scopeID,
                propertyToRead: propertyToRead
            },
            cache: serviceCache
        });
    };

    this.processData = function (scopeID) {
        return $http.put(baseUrl + '/ProcessData', { scopeID: scopeID }, { cache: serviceCache });
    };


    //---------------------------------------
    // FICAVAM NO MONITOR
    //---------------------------------------

    this.getScope = function (scopeID) {
        return $http.get(baseUrl + '/GetScope', { params: { scopeID: scopeID }, cache: serviceCache });
    };

    this.getIntegration = function (integrationID) {
        return $http.get(baseUrl + '/GetIntegration', { params: { id: integrationID }, cache: serviceCache });
    };

    this.getIntegrationScopes = function (integrationID, skipNumber, takeNumber, errorOnly) {
        return $http.get(baseUrl + '/GetScopes', { params: { id: integrationID, skipNumber: skipNumber, takeNumber: takeNumber, errorOnly: errorOnly }, cache: serviceCache });
    };
}

seedWebServices.service('IntegrationScopeService', ['$resource', '$routeParams', '$http', '$cacheFactory', '$q', '$filter', 'ToastService', IntegrationScopeService]);
